import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { ACL } from "../../components/acl";
import { SUPERADMIN, FINANCEADMIN } from "../../constants/roles";
import AppTile from "./components/AppTile";
import EmptyState from "./components/EmptyState";
import AddAppModal from "./components/AddAppModal";
import CredentialsDisplay from "./components/CredentialsDisplay";

export default function AppsPage() {
  const dispatch = useDispatch();
  const { list: rawList, loading, rotatedSecret } = useSelector((s) => s.apps);
  const list = Array.isArray(rawList) ? rawList : [];
  // House convention: role is read from localStorage (matches ACL component and peer views like notes.js)
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingApp, setEditingApp] = useState(null);

  useEffect(() => {
    dispatch(actions.FETCH_APPS_REQ());
  }, [dispatch]);

  const filtered = list.filter(
    (app) => app.name.toLowerCase().includes(search.toLowerCase())
  );

  const isSuper = [SUPERADMIN, FINANCEADMIN].includes(user.role);

  return (
    <main className="-mt-24">
      <div className="mx-auto max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div className="flex flex-1 space-x-4">
          <section className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <div className="h-full">
              <div className="relative min-h-[75vh] w-full overflow-hidden bg-white rounded-lg shadow px-4 flex flex-col">
        <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <h1 className="text-[22px] font-bold text-slate-900 leading-none">Apps</h1>
            <span className="inline-flex items-center justify-center h-6 min-w-[28px] px-2 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold">
              {filtered.length}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <div className="relative">
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
              <input
                type="text"
                placeholder="Search apps..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-9 pr-4 py-2 w-72 border border-slate-200 rounded-md text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
              />
            </div>
            <ACL showFor={[SUPERADMIN, FINANCEADMIN]}>
              <button
                onClick={() => { setEditingApp(null); setModalOpen(true); }}
                className="inline-flex items-center gap-1.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold px-4 py-2 rounded-md shadow-sm transition-colors"
              >
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add App
              </button>
            </ACL>
          </div>
        </div>

        {loading ? (
          <div className="flex-1 flex items-center justify-center text-slate-400">Loading...</div>
        ) : filtered.length === 0 ? (
          <EmptyState isSuperAdmin={isSuper} onAddClick={() => setModalOpen(true)} />
        ) : (
          <div className="p-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {filtered.map((app) => (
              <AppTile
                key={app.id}
                app={app}
                isSuperAdmin={isSuper}
                onEdit={() => { setEditingApp(app); setModalOpen(true); }}
              />
            ))}
          </div>
        )}
              </div>
            </div>
          </section>
        </div>
      </div>

      {modalOpen && (
        <AddAppModal
          editingApp={editingApp}
          onClose={() => { setModalOpen(false); setEditingApp(null); }}
        />
      )}

      {rotatedSecret && (
        <CredentialsDisplay
          app={rotatedSecret}
          variant="rotated"
          onClose={() => dispatch(actions.ROTATE_APP_SECRET_RESPONSE(null))}
        />
      )}
    </main>
  );
}
